import { initFederation } from '@angular-architects/native-federation';
import { environment } from './environments/environment';

initFederation(environment.federation.manifest)
    .catch((err) => console.error(err)) // eslint-disable-line no-console
    .then((_) => import('./bootstrap'))
    .catch((err) => console.error(err)); // eslint-disable-line no-console
